export var TextureDimension;
(function (TextureDimension) {
    TextureDimension[TextureDimension["Tex2D"] = 0] = "Tex2D";
    TextureDimension[TextureDimension["Cube"] = 1] = "Cube";
    TextureDimension[TextureDimension["Tex3D"] = 2] = "Tex3D";
    TextureDimension[TextureDimension["Texture2DArray"] = 3] = "Texture2DArray";
    TextureDimension[TextureDimension["CubeArray"] = 4] = "CubeArray";
    TextureDimension[TextureDimension["Unkonw"] = 5] = "Unkonw";
    TextureDimension[TextureDimension["None"] = 6] = "None";
})(TextureDimension || (TextureDimension = {}));
